<template>
  <div class="animated fadeIn">
    <b-tabs card>
      <b-tab title="Staff" active>
        <h3>Staff</h3>
        <staff-server-table :show_columns="['last_name', 'email', 'work_groups.name']" />
      </b-tab>
      <b-tab title="Instruments">
        <h3>Instruments</h3>
        <instrument-instance-server-table
          :show_columns="['name', 'instrument.name', 'priority', 'description']"
        />
      </b-tab>
      <b-tab title="Test Packages">
        <h3>Test Packages</h3>
        <test-package-server-table
          :show_columns="[
            'name',
            'sample_type.name',
            'test_package_group.name',
            'description',
            'cost',
            'cost_add_on'
          ]"
        />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import InstrumentInstanceServerTable from "@/components/lab/instrumentinstance/InstrumentInstanceServerTable";
import StaffServerTable from "@/components/lab/staff/StaffServerTable";
import TestPackageServerTable from "@/components/lab/testpackage/TestPackageServerTable";

export default {
  name: "LaboratoryDetailCardstack",
  components: {
    StaffServerTable,
    InstrumentInstanceServerTable,
    TestPackageServerTable
  }
};
</script>
